import { getTaxExemptData } from '../selectors/cart'
import { getOrderInProgress } from '../selectors/order'

export const getTaxClasses = (state) => {
  return state.VNTaxes?.taxClasses || {}
}

export const getTaxRules = (state) => {
  return state.VNTaxes?.taxRules || {}
}

export const getIsOrderTaxExempt = (state) => {
  const orderInProgress = getOrderInProgress(state)
  const taxExemptData = getTaxExemptData(state)

  return orderInProgress?.taxExempt || taxExemptData?.taxExempt || false
}

export const getTaxExemptApproverUuid = (state) => {
  const orderInProgress = getOrderInProgress(state)
  const taxExemptData = getTaxExemptData(state)

  return orderInProgress?.taxExemptApproverUuid || taxExemptData?.taxExemptApproverUuid || null
}
